import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
	selector: 'cv-quality-score-user-cell-renderer',
	templateUrl: './quality-score-user-cell-renderer.component.html',
	styleUrls: ['./quality-score-user-cell-renderer.component.scss']
})
export class QualityScoreUserCellRendererComponent implements AgRendererComponent {

	constructor(
		public cvLocalizationService: CVLocalizationService,
	) { }

	params: ICellRendererParams;
	inactiveMessage = '';

	async agInit(params: ICellRendererParams) {
		this.params = params;
		await this.cvLocalizationService.GetSection('Groups');
		this.inactiveMessage = `${params.data.Group.groupName} (${this.cvLocalizationService.getCachedText('Groups', 'Inactive', 'Inactive')})`;
	}

	refresh(params: ICellRendererParams) {
		this.params = params;
		return true;
	}
}
